import React, { useEffect, useRef, useState } from "react";

export default function DeferredEditForm({
  value,
  onCommit,
  onClose,
  children,
}: {
  value: any;
  onCommit: (value: any) => void;
  onClose: () => void;
  children: (
    draft: any,
    setDraft: React.Dispatch<React.SetStateAction<any>>
  ) => React.ReactNode;
}) {
  const [draft, setDraft] = useState(value);
  const draftRef = useRef(draft);
  const onCommitRef = useRef(onCommit);

  useEffect(() => {
    draftRef.current = draft;
  }, [draft]);

  useEffect(() => {
    onCommitRef.current = onCommit;
  }, [onCommit]);

  const handleCancel = () => {
    onClose();
  };

  const handleSave = () => {
    onCommitRef.current(draftRef.current);
    onClose();
  };

  return (
    <>
      {children(draft, setDraft)}
      <div className="d-flex justify-content-end gap-2 mt-4">
        <button type="button" className="btn btn-light" onClick={handleCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn-colored" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
